import {
  LineChartOutlined,
  ApartmentOutlined,
  BankOutlined,
  BranchesOutlined,
  BarChartOutlined,
  CloudDownloadOutlined,
  SettingOutlined,
  GroupOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

export const TempItems = [
  // getItem("TreeChart", "1", <ApartmentOutlined />),
  // getItem("PlantForm", "4", <BankOutlined />),
  getItem("LiveModule", "2", <LineChartOutlined />, [
    getItem("Live Trends", "sub1"),
    getItem("Meter Status", "sub2"),
    getItem("Convertor Status", "sub3"),
  ]),
  getItem("Historical Module", "3", <BarChartOutlined />, [
    // getItem("Comparative Report", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    // getItem("Consumption Report", "sub7"),
  ]),
];

export const TempNavItems = [
  // { path: "/temperature-dashboard/tree-chart", id: "1" },
  // { path: "/temperature-dashboard/plant-form", id: "4" },
  { path: "/temperature-dashboard/temp-live-trends", id: "sub1" },
  { path: "/temperature-dashboard/meter-status", id: "sub2" },
  { path: "/temperature-dashboard/temperature-convertor-status", id: "sub3" },
  { path: "/temperature-dashboard/temp-comparative-report", id: "sub4" },
  { path: "/temperature-dashboard/temp-raw-data", id: "sub5" },
  { path: "/temperature-dashboard/temp-historical-trends", id: "sub6" },
  { path: "/temperature-dashboard/temp-consumption-report", id: "sub7" },
];

export const AirItems = [
  // getItem("TreeChart", "1", <ApartmentOutlined />),
  // getItem("PlantForm", "4", <BankOutlined />),
  getItem(
    "LiveModule",
    "2",
    <LineChartOutlined />
    //    [
    //   getItem("Live Trends", "sub1"),
    //   getItem("Meter Status", "sub2"),
    //   getItem("Convertor Status", "sub3"),
    // ]
  ),
  getItem("Historical Module", "3", <BarChartOutlined />, [
    getItem("Comparative Report", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    getItem("Consumption Report", "sub7"),
  ]),
];

export const AirNavItems = [
  // { path: "/air-dashboard/tree-chart", id: "1" },
  // { path: "/air-dashboard/plant-form", id: "4" },
  { path: "/air-dashboard/air-live-trends", id: "sub1" },
  { path: "/air-dashboard/meter-status", id: "sub2" },
  { path: "/air-dashboard/air-convertor-status", id: "sub3" },
  { path: "/air-dashboard/air-comparative-report", id: "sub4" },
  { path: "/air-dashboard/air-raw-data", id: "sub5" },
  { path: "/air-dashboard/air-historical-trends", id: "sub6" },
  { path: "/air-dashboard/air-consumption-report", id: "sub7" },
];

export const ElectricalItems = [
  // getItem("TreeChart", "1", <ApartmentOutlined />),
  // getItem("Alerts", "1", <ApartmentOutlined />),

  // getItem("Dashboard", "3", <AppstoreOutlined />),
  getItem("Live Module", "2", <LineChartOutlined />, [
    getItem("Live Trends", "sub1"),
    getItem("Meter Status", "sub2"),
    getItem("Parameter View", "sub3"),
    // getItem("Plot Interval", "sub16"),
    // getItem("Status View", "sub15"),
  ]),
  getItem("Historical ", "5", <BarChartOutlined />, [
    getItem("Comparative ", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    getItem("Consumption ", "sub7"),
  ]),
  getItem("Group", "1", <GroupOutlined />, [
    getItem("Group", "sub8"),
    getItem("Sub Group", "sub9"),
    getItem("Group Config", "sub10"),
    getItem("Group Report", "sub11"), 
    // getItem("Alerts", "sub12"),
  ]),
  getItem("Manual Entry", "3", <ApartmentOutlined />, [
    getItem("Manual Data ", "sub14"),
    getItem("Manual Configuration", "sub13"),
  ]),
];

export const ElectricalNavItems = [
  // { path: "/electrical-dashboard/tree-chart", id: "1" },
  { path: "/electrical-dashboard/alerts", id: "sub12" },
  { path: "/electrical-dashboard/manual", id: "sub13" },
  { path: "/electrical-dashboard/manual-entry-data", id: "sub14" },
  { path: "/electrical-dashboard/status-view", id: "sub15" },
  { path: "/electrical-dashboard/plot-interval", id: "sub16" },

  { path: "/electrical-dashboard/livemodule-chart", id: "2" },
  { path: "/electrical-dashboard/live-trends", id: "sub1" },
  { path: "/electrical-dashboard/meter-status", id: "sub2" },
  { path: "/electrical-dashboard/parameter-view", id: "sub3" },
  { path: "/electrical-dashboard/dashboard", id: "3" },
  // { path: "/electrical-dashboard/plant-form", id: "4" },
  { path: "/electrical-dashboard/comparative-report", id: "sub4" },
  { path: "/electrical-dashboard/raw-data", id: "sub5" },
  { path: "/electrical-dashboard/historical-trends", id: "sub6" },
  { path: "/electrical-dashboard/consumption-report", id: "sub7" },

  { path: "/electrical-dashboard/groups", id: "sub8" },
  { path: "/electrical-dashboard/sub-group", id: "sub9" },
  { path: "/electrical-dashboard/group-config", id: "sub10" },
  { path: "/electrical-dashboard/group-report", id: "sub11" },
];

export const WaterItems = [
  // getItem("TreeChart", "1", <ApartmentOutlined />),
  // getItem("PlantForm", "4", <BankOutlined />),
  getItem("LiveModule", "2", <LineChartOutlined />, [
    getItem("Live Trends", "sub1"),
    getItem("Meter Status", "sub2"),
    getItem("Convertor Status", "sub3"),
  ]),
  getItem("Historical Module", "3", <BarChartOutlined />, [
    getItem("Comparative Report", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    getItem("Consumption Report", "sub7"),
  ]),
];

export const WaterNavItems = [
  // { path: "/water-dashboard/tree-chart", id: "1" },
  // { path: "/water-dashboard/plant-form", id: "4" },
  { path: "/water-dashboard/water-live-trends", id: "sub1" },
  { path: "/water-dashboard/meter-status", id: "sub2" },
  { path: "/water-dashboard/water-convertor-status", id: "sub3" },
  { path: "/water-dashboard/water-comparative-report", id: "sub4" },
  { path: "/water-dashboard/water-raw-data", id: "sub5" },
  { path: "/water-dashboard/water-historical-trends", id: "sub6" },
  { path: "/water-dashboard/water-consumption-report", id: "sub7" },
];

export const SteamItems = [
  // getItem("Dashboard", "1",<CloudDownloadOutlined />),
  getItem("LiveModule", "2", <LineChartOutlined />, [
    getItem("Live Trends", "sub1"),
    getItem("Meter Status", "sub2"),
    getItem("Convertor Status", "sub3"),
  ]),
  getItem("Historical Module", "3", <BarChartOutlined />, [
    getItem("Comparative Report", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    getItem("Consumption Report", "sub7"),
  ]),
];

export const SteamNavItems = [
  // { path: "/steam-dashboard/tree-chart", id: "1" },
  { path: "/steam-dashboard/steam-live-trends", id: "sub1" },
  { path: "/steam-dashboard/meter-status", id: "sub2" },
  { path: "/steam-dashboard/steam-convertor-status", id: "sub3" },
  { path: "/steam-dashboard/comparative-report", id: "sub4" },
  { path: "/steam-dashboard/raw-data", id: "sub5" },
  { path: "/steam-dashboard/historical-trends", id: "sub6" },
  { path: "/steam-dashboard/consumption-report", id: "sub7" },
];

export const ConfigurationItems = [
  getItem("Configuration", "1", <SettingOutlined />, [
    getItem("Converter Config", "sub1"),
    getItem("Device Config", "sub2"),
    // getItem("Converters & Meters", "sub7"),
    // getItem("Groups", "sub6"),
    // getItem("Manual Entry", "sub3"),
    // getItem("Emission Factor", "sub4"),
    // getItem("Dash Live ", "sub8"),
    // getItem("Dash Energy ", "sub9"),
    // getItem("User Registration", "sub4"),
  ]),
  // getItem("Group Configuration", "2", <SettingOutlined />, [
  //   getItem("group", "sub5"),
  //   getItem("sub-group", "sub6"),
  //   getItem("group-meter", "sub7"),
  // ]),
];

export const ConfigurationNavItems = [
  { path: "/configuration-dashboard/Converter-config", id: "sub1" },
  { path: "/configuration-dashboard/Device-config", id: "sub2" },
  { path: "/configuration-dashboard/Manual-Entry", id: "sub3" },
  // { path: "/configuration-dashboard/Application-Config", id: "sub3" },
  { path: "/configuration-dashboard/Emission-Factor", id: "sub4" },
  { path: "/configuration-dashboard/converters-meters", id: "sub7" },
  { path: "/configuration-dashboard/configuration-groups", id: "sub6" },
  { path: "/configuration-dashboard/configuration-live", id: "sub8" },
  { path: "/configuration-dashboard/configuration-energy", id: "sub9" },
  { path: "/configuration-dashboard/Group-config/group", id: "sub5" },
  // { path: "/configuration-dashboard/Group-config/sub-group", id: "sub6" },
  // { path: "/configuration-dashboard/Group-config/group-meter", id: "sub7" },

  // { path: "/configuration-dashboard/Steam-grouping/group", id: "sub8" },
  // { path: "/configuration-dashboard/Steam-grouping/sub-group", id: "sub9" },
  // { path: "/configuration-dashboard/Steam-grouping/group-meter", id: "sub10" },
  // { path: "/configuration-dashboard/Water-grouping/group", id: "sub11" },
  // { path: "/configuration-dashboard/Water-grouping/sub-group", id: "sub12" },
  // { path: "/configuration-dashboard/Water-grouping/group-meter", id: "sub13" },
];
